module.exports = __webpack_public_path__ + "media/images/franchises-db8d6169f98048f5e2ff31974eac6416.jpg";